export const BASE_SERVER_URL = process.env.REACT_APP_API_BASE_URL_CLIENT;
export const BASE_ML_URL = process.env.REACT_APP_ML_MODEL_BASE_URL;